import React, { useState, useEffect } from "react";
import {Box, Paper, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, Button, Stack, IconButton, } from '@mui/material';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import PageLoader from "../../../components/Loader/PageLoader"
import DeleteIcon from '@mui/icons-material/Delete';
import HeaderName from "../../../components/Custom/HeaderName";
import { EditIcon } from "../../../components/Icons";
import { storeEditCustomerDetails } from "../../../redux/Slices/customerSlice";
import Swal from "sweetalert2";
import { deleteOfficeDetails } from "../../../redux/Thunk/officeThunk";
import { getDocketList } from "../../../redux/Thunk/docketThunk";
import VisibilityIcon from '@mui/icons-material/Visibility';

const DocketList =() =>{
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [totalCount, setTotalCount] = useState(0)
  const role = localStorage.getItem('role');
  const [selectedRows, setSelectedRows] = useState([]);
  const [search,setSearch] = useState('');
  const [docketList, setDocketList] = useState([])
  // pagination
  const [page, setPage] = useState({
    page:0,
    pageSize:10
  })

  useEffect(()=>{
    fetchDocket()
  },[page])

  // get all Office details
  const fetchDocket = async () => {
    setLoader(true)
    dispatch(getDocketList({page: page.page + 1, limit: page.pageSize, search: ""})).then((res) => {
      setDocketList(res?.payload?.data)
      setTotalCount(res?.payload?.total)
      setLoader(false)
    })
  };

  const handleRowSelection = (selection) => {
    if (selection?.length === 0) {
      // If no rows selected, clear the selected rows
      setSelectedRows([]);
    } else {
      // Map the selected IDs to their corresponding rows
      // const selectedRows = selection?.map(selectedId =>
      //   facilityList.find(row => row?._id === selectedId)
      // );
      setSelectedRows(selectedRows);
    }
  };

  // Edit Office details
  const handleClickEditOffice =(details) =>{
    // navigate('/dashboard/docketList/newoffice', {state:{editDetails:details}})
  }

  // Deleted Customer details
  const handleClickDeleteOffice =(row) =>{
    //   Swal.fire({ 
    //     title: `Are you sure you want to delete the selected Office?`,
    //     showCancelButton: true,
    //     confirmButtonText: 'Delete',
    //     showLoaderOnConfirm: true,
    //     allowOutsideClick: () => !Swal.isLoading(),
    //     preConfirm: () => {
    //       return dispatch(deleteOfficeDetails({Id: row?.OfficeId, type:'OfficeAdmin'})).then((res)=>{
    //         if (res?.payload?.success === true && res?.payload?.warning === true) {
    //           Swal.fire('Warning!', res?.payload?.message, 'warning');
    //           fetchDocket()
    //           setSelectedRows([])
    //         }else if(res?.payload?.success === true){
    //           Swal.fire('Deleted!', res?.payload?.message, 'delete');
    //           fetchDocket()
    //           setSelectedRows([])
    //         }else{
    //           Swal.fire('Error!', res?.payload?.message, 'error');
    //         }
    //       });
    //     },
    //   });
  }

  const columns = [
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Sr.No',
      align:'center',
      headerName: 'Sr. No',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', padding:1, alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{textAlign:'left',}}>
              {page?.page * page?.pageSize + params.api.getAllRowIds().indexOf(params.id)+1}
            </Typography>
          </Box>
        )
      }
    },
    {
      flex: 0.25,
      minWidth: 120,
      field: 'DocketId',
      headerName: 'Id',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography noWrap variant='body2' sx={{textAlign:'left',}}>
              {row?.DocketId}
            </Typography>
          </Box>
        )
      }
    },
    // {
    //   flex: 0.25,
    //   minWidth: 120,
    //   field: 'RequestedId',
    //   headerName: 'Requested Id',
    //   align:'center',
    //   renderCell: params => {
    //     const { row } = params
  
    //     return (
    //       <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    //         <Typography noWrap variant='body2' sx={{textAlign:'left',}}>
    //           {row?.RequestedId}
    //         </Typography>
    //       </Box>
    //     )
    //   }
    // },
    {
      flex: 0.4,
      minWidth: 150,
      field: 'Customer Name',
      headerName: 'Customer Name',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.pickupDetails?.customer[0]?.CustomerName || ''}
            </Typography>
          </Box>
        )
      }
    }, 
    {
      flex: 0.20,
      minWidth: 120,
      field: 'Origin',
      headerName: 'Origin',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.pickupDetails?.Origin}
            </Typography>
          </Box>
        )
      }
    },
    {
        flex: 0.20,
        minWidth: 120,
        field: 'Destination',
        align:'center',
        headerName: 'Destination',
        renderCell: params => {
          const { row } = params
    
          return (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
                {row?.pickupDetails?.Destination}
              </Typography>
            </Box>
          </>
          )
        }
    },
     {
      flex: 0.55,
      minWidth: 220,
      field: 'Pickup Address',
      align:'center',
      headerName: 'Pickup Address',
      renderCell: params => {
        const { row } = params
  
        return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.pickupDetails?.PickupAddress || '--'}
            </Typography>
          </Box>
        </>
        )
      }
    },
    {
      flex: 0.5,
      minWidth: 220,
      field: 'Destination Address',
      align:'center',
      headerName: 'Destination Address',
      renderCell: params => {
        const { row } = params
  
        return (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.pickupDetails?.DestinationAddress || '--'}
            </Typography>
          </Box>
        </>
        )
      }
    },
     {
        flex: 0.35,
        minWidth: 120,
        field: 'Status',
        align:'center',
        headerName: 'Status',
        renderCell: params => {
        const { row } = params
          return (<>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
              {row?.pickupDetails?.Status || '--'}
            </Typography>
          </Box>
          </>
          )
        }
    },
    // {
    //   flex: 0.5,
    //   minWidth: 220,
    //   field: 'Time',
    //   align:'center',
    //   headerName: 'Time',
    //   renderCell: params => {
    //     const { row } = params
  
    //     return (
    //     <>
    //       <Box sx={{ display: 'flex', alignItems: 'center' }}>
    //         <Typography noWrap variant='body2' sx={{maxWidth: '100%', whiteSpace: 'pre-line', wordBreak: 'break-all', flex: 1}}>
    //           {/* {row?.Address || '--'} */}
    //         </Typography>
    //       </Box>
    //     </>
    //     )
    //   }
    // },
    {
      flex: 0.1,
      minWidth: 80,
      field: 'Action',
      headerName: 'Action',
      align:'center',
      renderCell: params => {
        const { row } = params
  
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography noWrap variant='body2'>
                <IconButton id='edit' onClick={() => navigate('/dashboard/docketlist/docketformat', {state:{docketData:row}})}><VisibilityIcon style={{color:'#04AB44'}}/></IconButton>
                {/* <IconButton id='delete' onClick={()=> handleClickDeleteOffice(row)}><DeleteIcon fontSize="medium" style={{color:'#04AB44'}}/></IconButton> */}
              </Typography>
            </Box>
          </Box>
        )
      }
    },    
  ]

    return(
        <>
          <div style={{display:'flex', flexDirection:'column', flexGrow: 1}}>
            {/* <Header /> */}
            { loader ? <PageLoader /> : 
               <Grid container style={{padding:'0px 10px', width: '94%', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>   
                <Grid size={{ xs: 12, sm: 12, md: 12, lg:12 }}>
                  <HeaderName headerName={'Docket List'} onClickBackButton={()=> navigate("/dashboard")} />
                  <div className="custom-data-grid-container_table">
                    <DataGrid
                      sx={{
                        borderRadius: "31px",
                        overflow: "auto",
                      }}
                      style={{ width: '100%' }}
                      pagination
                      // checkboxSelection
                      rows={docketList}
                      rowHeight={56}
                      rowCount={totalCount}
                      getRowId={param=> param._id}
                      columns={columns}
                      paginationModel={page}
                      sortingMode='server'
                      paginationMode='server'
                      pageSizeOptions={[10, 50, 100]}
                      onPaginationModelChange={(newPage)=>setPage(newPage)}
                      className="custom-data-grid"
                      selectionModel={selectedRows ? [selectedRows] : []}
                      onRowSelectionModelChange={handleRowSelection}
                      initialState={{
                        totalCount,
                        pagination: { paginationModel: {page:1, pageSize: 10}},
                      }}
                      disableRowSelectionOnClick
                      disableColumnMenu
                      disableColumnFilter
                      disableColumnSorting
                    />
                  </div>
                </Grid>
              </Grid>
            }
          </div>
        </>
    )
}

export default DocketList